import { Link } from 'react-router-dom';  
import paths from '../../routes/paths';  
import whatsappBtn from '../../assets/images/whatsappbtn.png'
import MetaTags from '../Common/MetaTags';
const  ContactUs = () => {   
    return (
        <>
          <MetaTags
            title="Contact Us | Anuugha Collections"
            description="Have questions or need assistance? Contact Anuugha Collections for support and inquiries. We're here to help."
            url="https://www.anuughacollections.com/contact-us"
            image={process.env.REACT_APP_SERVER_URL + whatsappBtn}
            />
        
            <div className="page-content bg-light">

                <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
                <div className="container">
                    <div className="dz-bnr-inr-entry">
                    <h1>Contact Us</h1>
                    <nav aria-label="breadcrumb" className="breadcrumb-row">
                        <ul className="breadcrumb">
                        <li className="breadcrumb-item"><Link to={paths.store} className=" menu-title ">Home</Link></li>
                        <li className="breadcrumb-item">Contact Us</li>
                        </ul>
                    </nav>
                    </div>
                </div>	
                </div> 
                <section className="content-inner">
                <div className="theme-page-section _pv-60 _ph-60 about_one free-shipping shipping-policy p-t-40 m-b-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="theme-hero-text theme-hero-text-center">
                                    <div className="theme-hero-text-header">
                                            <div className="order-tracking m-t-30">
                                                <div className="container">
                                                    <div className="row">
                                                    
                                                        <div className="col-md-12 col-6 text-free-shipping lImage">
                                                            <div className="text-center text p-t-60">
                                                                <h2> Connect with Us</h2>
                                                                <p className="text-center">Now you can connect with us via WhatsApp.</p> 
                                                                <p className="text-center">
                                                                    <a rel="nofollow noopener noreferrer" target="_blank" href="https://wa.me/+918499919988?text=" title="connect with us" className="flex-c-m trans-04 p-lr-25" >
                                                                            <img src={whatsappBtn} alt="whtsapp link" />
                                                                            
                                                                    </a>
                                                                </p>
                                                            </div>   
                                                        </div>
                                                        
                                                    </div> 
                                                </div>
                                            </div>
                                        
                                    </div>
                                </div>
                                <section className="bg0 p-t-60 p-b-15 app-content category-content m-b-60">
                                <div className="container">
                                    <div className="p-b-10 header">
                                        <h1>Contact Anuugha Collections</h1>
                                    </div>
                                    <div className="content">
                                        <p>Welcome to Anuugha Collections, your premier destination for breathtaking sarees and ethnic wear. We value your inquiries and are committed to providing exceptional customer service. Whether you have questions about our products, need assistance with an order, or want personalized styling advice, our team is here to help.</p>
                                        
                                        <h2>Contact Information:                            </h2>
                                        <p>Feel free to reach out to us using the following contact details:</p>
                                        <ul>
                                            <li><b>Email:</b> anuughacollections@gmail.com</li>
                                            <li><b>WhatsApp:</b> +91 8499919988</li>
                                            <li><b>Address:</b>Anuugha Collections, Plot 221, SR Nagar, Hyderabad - 38, Telangana, India</li>
                                        </ul>
                                        <h2>Customer Support Hours:</h2>
                                        <ul>
                                        <li>Monday to Friday: 11:00 AM - 6:00 PM (IST)</li>
                                        <li>Saturday: 11:00 AM - 3:00 PM (IST)</li>
                                        <li>Sunday: Closed</li>
                                        </ul>
                                        <h2>Connect With Us: </h2>
                                        <p>Follow us on social media to stay updated on the latest collections, promotions, and styling tips:</p>
                                        <ul>
                                            <li>
                                                <a href="https://www.instagram.com/anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-16  primary-txt hov-cl1 trans-04 m-r-16">
                                                    <i className="fab fa-instagram"></i> Instagram
                                                </a>
                                            </li>
                                        <li> 
                                                <a href="https://www.facebook.com/anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-16 primary-txt hov-cl1 trans-04 m-r-16">
                                                    <i className="fab fa-facebook-f"></i> Facebook
                                                </a>
                                            </li>
                                        <li>
                                                <a href="https://www.youtube.com/@anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-16 primary-txt hov-cl1 trans-04 m-r-16">
                                                    <i className="fa-brands fa-youtube"></i> Youtube
                                                </a>
                                            </li>
                                        
                                        </ul>
                                        <h2>
                                            Location Map:
                                        </h2>
                                        <p>
                                            <div className="contactUsMap">
                                                <div id="embed-map-canvas">
                                                    <iframe title="location map"  src="https://www.google.com/maps/embed/v1/place?q=anuugha+collections&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
                                                </div>
                                            
                                            </div>
                                        </p>
                                        <h2>Why Choose Anuugha Collections:</h2>
                                        <p>At Anuugha Collections, we are passionate about delivering exceptional products and service. Our sarees are crafted with precision, showcasing the perfect blend of tradition and modernity. Your journey with Anuugha Collections is not just about buying clothing; it's about embracing a lifestyle of timeless elegance.</p>
                                        <p>At Anuugha Collections, we value your feedback and strive to provide excellent service. Your messages are important to us, and we will do our best to respond promptly. Thank you for choosing Anuugha Collections for your saree needs.</p>
                                    

                            

                                

                                
                                    </div>
                                </div>
                            </section>
                            </div>
                        </div>
                    </div>
                </div> 
                </section>
        
            </div>
        </> 
    );
}

export default ContactUs;

 
